import { db } from '@/firebase.js';
export default({
  state:{
    textsAdmin: []
  },
  mutations:{
    bindAdminTexts(state){
      db.collection('teksty').get().then(querySnapshot=>{
        querySnapshot.forEach(doc=>{
            let title = doc.data().title;
            let content = doc.data().content;
            let edit = doc.data().edit;
            let id = doc.data().id;
            state.textsAdmin.push({
                title, content, edit, id
            });
        });
    });
  },
  editText(__state, data){
    // console.log(data)
    db.collection('teksty').doc(data.title).update({
      edit: true
    })
  }
  },
  actions:{
    editText({commit}, data){
      commit('editText', data);
    }
  },
  getters:{}
})